// Entry point for the build script in your package.json

import "@hotwired/turbo-rails"
import "./babyfriendly"

Turbo.session.drive = false
